import { SvgIcon, SvgIconProps } from '@mui/material'

export const Icon = {
  Light: (props: SvgIconProps) => {
    return (
      <SvgIcon viewBox="0 0 16 16" {...props}>
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
          <g clipPath="url(#clip0_2389_31646)">
            <path
              d="M6.99238 3.89874C5.49153 4.24867 4.28337 5.43889 3.91444 6.93096C3.54434 8.4278 3.96791 9.95352 5.04753 11.0122C5.42941 11.3868 5.65744 11.987 5.65744 12.618V12.7187C5.65744 13.1342 5.83872 13.5081 6.12619 13.7658V14.5937C6.12619 15.3691 6.75703 16 7.53244 16H8.46994C9.24534 16 9.87619 15.3691 9.87619 14.5937V13.7658C10.1637 13.5081 10.3449 13.1343 10.3449 12.7187V12.6162C10.3449 11.9948 10.5852 11.3831 10.9875 10.9799C11.7822 10.1834 12.2199 9.12514 12.2199 7.99999C12.2199 5.31002 9.72716 3.2613 6.99238 3.89874ZM8.93869 14.5937C8.93869 14.8522 8.72841 15.0625 8.46994 15.0625H7.53244C7.27397 15.0625 7.06369 14.8522 7.06369 14.5937V14.125H8.93869V14.5937ZM10.3239 10.3177C9.74147 10.9013 9.40744 11.7391 9.40744 12.6162V12.7187C9.40744 12.9772 9.19716 13.1875 8.93869 13.1875H7.06369C6.80522 13.1875 6.59494 12.9772 6.59494 12.7187V12.618C6.59494 11.7274 6.27016 10.8982 5.70391 10.3429C4.86359 9.51883 4.53487 8.32749 4.8245 7.15599C5.10966 6.00264 6.04416 5.08246 7.20525 4.81177C9.35125 4.31136 11.2824 5.91336 11.2824 7.99999C11.2824 8.87511 10.942 9.69821 10.3239 10.3177Z"
              fill="currentColor"
            />
            <path
              d="M4.35261 3.69108L3.02677 2.36526C2.84373 2.1822 2.54692 2.1822 2.36386 2.36526C2.1808 2.54833 2.1808 2.84511 2.36386 3.02817L3.6897 4.35398C3.87273 4.53704 4.16958 4.53704 4.35261 4.35398C4.53567 4.17092 4.53567 3.87414 4.35261 3.69108Z"
              fill="currentColor"
            />
            <path
              d="M2.375 7.53125H0.46875C0.209875 7.53125 0 7.74112 0 8C0 8.25888 0.209875 8.46875 0.46875 8.46875H2.375C2.63387 8.46875 2.84375 8.25888 2.84375 8C2.84375 7.74112 2.63387 7.53125 2.375 7.53125Z"
              fill="currentColor"
            />
            <path
              d="M15.5312 7.53125H13.625C13.3661 7.53125 13.1562 7.74112 13.1562 8C13.1562 8.25888 13.3661 8.46875 13.625 8.46875H15.5312C15.7901 8.46875 16 8.25888 16 8C16 7.74112 15.7901 7.53125 15.5312 7.53125Z"
              fill="currentColor"
            />
            <path
              d="M13.6358 2.36526C13.4528 2.1822 13.156 2.1822 12.9729 2.36526L11.6471 3.69108C11.464 3.87411 11.464 4.17092 11.6471 4.35398C11.8301 4.53704 12.1269 4.53704 12.31 4.35398L13.6358 3.02817C13.8189 2.84514 13.8189 2.54833 13.6358 2.36526Z"
              fill="currentColor"
            />
            <path
              d="M8 0C7.74112 0 7.53125 0.209875 7.53125 0.46875V2.375C7.53125 2.63387 7.74112 2.84375 8 2.84375C8.25888 2.84375 8.46875 2.63387 8.46875 2.375V0.46875C8.46875 0.209875 8.25888 0 8 0Z"
              fill="currentColor"
            />
            <path
              d="M8.00333 5.65625C7.81064 5.65625 7.61436 5.67934 7.42027 5.72481C6.61199 5.91347 5.93533 6.57881 5.73655 7.38041C5.67424 7.63169 5.82739 7.88587 6.07864 7.94822C6.32996 8.01053 6.58414 7.85731 6.64646 7.60609C6.76086 7.14491 7.16667 6.74672 7.63374 6.63769C7.75817 6.60853 7.88255 6.59375 8.00333 6.59375C8.26221 6.59375 8.47208 6.38388 8.47208 6.125C8.47208 5.86612 8.26221 5.65625 8.00333 5.65625Z"
              fill="currentColor"
            />
          </g>
          <defs>
            <clipPath id="clip0_2389_31646">
              <rect width="16" height="16" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </SvgIcon>
    )
  },
  Loading: (props: SvgIconProps) => {
    return (
      <SvgIcon
        viewBox="0 0 20 20"
        {...props}
        sx={{
          animation: 'spin 1s linear infinite',
          '@keyframes spin': {
            '0%': {
              transform: 'rotate(0deg)',
            },
            '100%': {
              transform: 'rotate(360deg)',
            },
          },
          ...props.sx,
        }}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path
            d="M10 20C4.49 20 0 15.51 0 10C0 8.13 0.52 6.31 1.5 4.73C1.79 4.26 2.41 4.12 2.88 4.41C3.35 4.7 3.49 5.31999 3.2 5.78999C2.42 7.04999 2 8.51 2 10C2 14.41 5.59 18 10 18C14.41 18 18 14.41 18 10C18 5.59 14.41 2 10 2C9.45 2 9 1.55 9 1C9 0.45 9.45 0 10 0C15.51 0 20 4.49 20 10C20 15.51 15.51 20 10 20Z"
            fill="currentColor"
          />
        </svg>
      </SvgIcon>
    )
  },
}
